import moment from 'moment'

function dateFormat(dataStr, formatStr) {
  return moment(dataStr, 'YYYY-MM-DDTHH:mm:ssZ', 'zh-cn').format(formatStr)
}

export default {
  dateFormat,
}
